module.exports = {
      id: "logo-usage",
      viewBox: "0 0 997.64 195.19",
      url: __webpack_public_path__ + "svg-sprite-fef6f85605acbf641cce7cd75d6011b0.svg#logo",
      toString: function () {
        return this.url;
      }
    }